<template>
    <div id="PurchaseOrderList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="cantAccessPage === true">
          <div class="admin-page-content customer-detail">
            <!-- Button for Clear Cache -->
            <div class="btn-groups text-right">
                <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                <router-link v-if="addPurchaseOrder" class="btn btn-primary" v-bind:to="{path: createPagePath}">
                    <i class="fp-add"></i> Add
                </router-link>
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
            <data-table-filter-config :moduleName="moduleN" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                      <custom-pagination
                          :page-changed="onPageChange"
                          :per-page-changed="onPerPageChange" :moduleName="moduleN" :position="'top'">
                      </custom-pagination>

                      <vue-good-table
                          ref="listPurchaseOrder"
                          mode="remote"
                          title="Purchase Order"
                          @on-page-change="onPageChange"
                          @on-selected-rows-change="selectionChanged"
                          @on-column-filter="onColumnFilter"
                          @on-per-page-change="onPerPageChange"
                          @on-sort-change="onSortChange"
                          @on-select-all="onSelectAll"
                          :totalRows="totalRecords"
                          :columns="userColumns"
                          :rows="rows"
                          :pagination-options="{
                              enabled: false,
                              position: 'both',
                              perPage: perPage,
                              perPageDropdown:dropDownPerPage,
                              dropdownAllowAll: false,
                          }"
                          :select-options="{
                                  enabled: purchase_order_value,
                                  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                  selectionInfoClass: 'custom-class',
                                  selectionText: 'rows selected',
                                  clearSelectionText: 'clear',
                          }"
                          :search-options="{
                          enabled: false,
                      }">
                          <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                              <div :key="key">
                                  <div v-if="props.column.field == 'action'" class='text-center'>
                                  <!--  &&  -->
                                      <router-link v-if="updatePurchaseOrder && props.row.is_processed == 'NO' && (props.row.status == 'Open' || props.row.status == 'Reserved') && props.row.type != 'sublet_po'" title="Edit Purchase Order" class="fp-edit" v-bind:to="{path: '/vendor-purchase-order/edit/'+props.row.id + viewPageParam}"></router-link>
                                  </div>
                                  <div v-else-if="props.column.field == 'po_no' && canViewPurchaseOrder === true" class='text-center'>
                                      <router-link title="View Purchase Order" class="color-blue"  v-bind:to="{path: '/vendor-purchase-order/view/'+props.row.id + viewPageParam,query:{fromUrl:fromUrl}}">{{props.row.po_no}}</router-link>
                                  </div>
                                  <div v-else>
                                      {{props.formattedRow[props.column.field]}}
                                  </div>
                              </div>
                          </template>

                          <div slot="selected-row-actions">
                              <!-- <template v-if="canCreateWorkOrder == true">
                                  <button id="createWorkOrderBtn" v-on:click.prevent="workOrderCreate" class="btn btn-success waves-effect">Create Work Order</button>
                              </template> -->
                              <template v-if="canCopyPO">
                                <button id="canCopyPOBtn" v-on:click.prevent="purchaseOrderCopy" class="btn btn-primary">Copy</button>
                              </template>
                              <template v-if="recordReceiptBtn">
                                  <button id="processPo" v-on:click="recordReceipt()" class="btn btn-secondary">Record Receipt</button>
                              </template>
                              <template v-if="processBtn">
                                  <button id="processPo" v-on:click="processPo('process')" class="btn btn-primary">Process</button>
                              </template>
                              <template v-if="unProcessBtn">
                                  <button id="processPo" v-on:click="processPo('unprocess')" class="btn btn-secondary">Un Process</button>
                              </template>
                              <button v-if="purchase_order_value" id="deletePurchaseOrderTypeBtn" v-on:click.prevent="PurchaseOrderDelete" class="btn btn-danger">Delete</button>
                          </div>
                      </vue-good-table>
                      <custom-pagination
                          :page-changed="onPageChange"
                          :per-page-changed="onPerPageChange">
                      </custom-pagination>
              </section>
            </div>
            <div class="modal fade copy-purchaseorder-modal" id="copy-purchaseorder-modal" ref="copyPurchaseOrderModal" data-backdrop="static" data-keyboard="false" aria-labelledby="copyPurchaseOrderModal" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div :class="`loader${loaderClass}`" v-show="loadingModal"></div>
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Copy Purchase Order</h5>
                            <button type="button" class="close" id="btnCopyPOClose" v-on:click="hideCopyPOModal()">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="form-row">
                                <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="poCopyForm">
                                    <div class="col-sm-12 form-group">
                                        <span>This function will copy this PO and create a new one.</span>
                                    </div>
                                    <!-- <div class="col-sm-12 form-group">
                                        <label class="control-label" for="po_no">Purchase Order:</label>
                                        <span>{{copyPONo}}</span>
                                    </div> -->
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label class="control-label" for="reverse_po">Reverse Sign?:</label>
                                            <div class="custome-radiobtn form-check-inline">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="reverse_po"> Yes
                                                        <input type="radio" v-model="reverse_po" :value="1" id="reverse_po" name="reverse_po">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="reverse_po"> No
                                                        <input type="radio" v-model="reverse_po" :value="0" id="reverse_po" name="reverse_po">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary" id="btnCopyPOProcess" v-on:click.prevent="createCopyPO()"> Confirm </button>
                            <button class="btn btn-tertiary" id="btnCopyPOCancel" v-on:click.prevent="hideCopyPOModal()"> Cancel </button>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
    </div>
</template>
<script>

    import EventBus from "./event-bus";
    import Vue from "vue";






    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "PurchaseOrderList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Vendor Purchase Order List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            vendorPurchaseVal: {
                type: String,
                required: false,
                default:undefined
            },
            vendorPurchaseStatus: {
                type: String,
                required: false,
                default:undefined
            },
            moduleN: {
                type: String,
                required: false,
                default:undefined
            },
        },
        data: () => ({

            firstLoad: 0,
            permissions: [],
            cantAccessPage: '',
            purchase_order_value:false,
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '#PO',
                    field: 'po_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "# PO", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Type',
                    field: 'typeName',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [{text:'Item',value:'item'},{text:'Equipment',value:'equipment'},{text:'Sublet PO',value:'sublet_po'},{text:'Misc',value:'misc'}],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Vendor',
                    field: 'vendor',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Vendor", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Order Date',
                    field: 'order_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Delivery Date',
                    field: 'delivery_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Open','Closed','Reserved','Sent'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Is Processed',
                    field: 'is_processed',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['YES','NO'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Ordering Location',
                    field: 'ordering_location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
            ],
            rows: [],
            totalRecords: 0,
            asset_value: false,
            loading:false,
            permit_value:false,
            addPurchaseOrder:false,
            updatePurchaseOrder:false,
            assetId:"",
            selectedFile:"",
            canViewPurchaseOrder:false,
            createPagePath:"/vendor-purchase-order/create",
            viewPageParam:"",
            action:'list',
            pageKey:"_vendor_po_list",
            from:'vendor',
            processBtn:false,
            unProcessBtn:false,
            recordReceiptBtn:false,
            fromUrl:"",
            batchProcess:0,
            batchNum:"",
            canCopyPO:false,
            copyPOId:"",
            copyPONo:"",
            reverse_po:0,
            loadingModal:false
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_purchase_order') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_purchase_order') {
                            self.addPurchaseOrder = true;
                            self.updatePurchaseOrder = true;
                        }
                        if (permissions[i].name == 'view_purchase_order') {
                            self.addPurchaseOrder = true;
                            self.canViewPurchaseOrder = true;
                        }
                        if (permissions[i].name == 'delete_purchase_order') {
                            self.purchase_order_value=true;
                        }
                        if (permissions[i].name == 'copy_purchase_order') {
                            self.purchase_order_value = true;
                            self.canCopyPO = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {

            var self = this;
            self.fromUrl = btoa(window.location.pathname+window.location.search);
            if ( this.vendorPurchaseVal == 'assetVendorPO' ) {
                this.createPagePath = "/vendor-purchase-order/create?from=asset";
                this.viewPageParam = "?from=asset";
                self.from = 'asset';
            }

            if (self.$route.query.from && self.$route.query.from == 'item') {
                self.from = "inventory";
            }

            self.getPermissions();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listPurchaseOrder.unselectAllInternal();
            },
        loadList() {

            var self = this;


            var data = this.$refs['listPurchaseOrder'].selectedRows;
            var selectedRows = [];

            for (var i = 0; i < data.length; i++) {
                selectedRows.push(self.$refs['listPurchaseOrder'].selectedRows[i].id)
            }

            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                all:self.serverParams.selectedAll,
                selectedRows:selectedRows,
                action:self.action,
                from:self.from,
                status: self.vendorPurchaseStatus
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/purchase_order/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if ( self.action == "delete" ) {

                            self.action = "list";
                            $("#deletePurchaseOrderTypeBtn").val("Delete");

                            if(data.processedPOs != ''){
                              self.$swal(data.message, data.processedPOs, 'warning');
                            }

                            self.$refs.filterComponent.clearSelectAll();
                            self.loadList();
                            EventBus.$emit('clear-all-flags', false);   //hide alert of selection

                        }else if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            EventBus.$emit("purchaseOrderCount", data.content.pocount);
                            EventBus.$emit("customerpurchaseOrderCount", data.content.custpocount);
                            self.filteredFlag = false;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if ( self.action == "delete" ) {
                        self.generateStatusCodeMessage(jqXHR, true, 'vendor-po-delete')
                    }else{
                        self.generateStatusCodeMessage(jqXHR, false, 'vendor-po-list')
                    }
                }
            });
        },
        PurchaseOrderDelete() {
            var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Purchase Order?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {

                      this.action = "delete";
                      $("#deletePurchaseOrderTypeBtn").val("Deleting ...");
                      this.loadList();

                    } else {
                      console.log("no");
                    }
                });

            /*var data = this.$refs['listPurchaseOrder'].selectedRows;
            var self = this;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(this.$refs['listPurchaseOrder'].selectedRows[i].id)
            }

            if (confirm('Are you sure that you want to delete this Purchase Order? ')) {

                self.loading = true;
                $("#deletePurchaseOrderTypeBtn").val("Deleting ...");
                $.ajax({
                    url: process.env.ROOT_API + "/purchase_order/delete",
                    type: "POST",
                    data: 'id=' + use,
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false;
                        setTimeout(function () {
                            $(".alert-success").removeClass("show");
                            $(".alert-success").addClass("hide");
                        }, 10000);
                        setTimeout(function () {
                            $("#deletePurchaseOrderTypeBtn").val("Delete");
                        }, 10000);
                        // self.rows = data.content.row;
                        if (data.code == '200') {
                            // self.rows = data.content.row;
                            // self.totalRecords = data.content.totalRecords;
                            self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('tkn');

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            }*/
        },
            workOrderCreate() {

                var self = this;

                if ( this.$refs['listPurchaseOrder'].selectedRows.length != 1 ) {
                    self.$swal('',"Kindly choose only one purchase order.",'info');
                    return;
                }

                if ( this.$refs['listPurchaseOrder'].selectedRows[0].work_order_no != '-' ) {
                    self.$swal('',"Work Order has already been created.",'info');
                    return;
                }

                if (confirm('Are you sure that you want to create Work Order from selected purchase order? ')) {
                    this.$router.push({ name: 'WorkOrderCreate', params:{purchaseOrderId: this.$refs['listPurchaseOrder'].selectedRows[0].id, redirectFrom: 'PurchaseOrderList'}})
                }

            },
            exportCheck: function() {
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listPurchaseOrder'].selectedRows;
                count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
                this.exportReports(actionFlag);
            },

            processPo: function(flag){
                var self = this;

                var selectedRows = [];

                var data = this.$refs['listPurchaseOrder'].selectedRows;

                for (var i = 0; i < data.length; i++) {
                    selectedRows.push(self.$refs['listPurchaseOrder'].selectedRows[i].id)
                }

                $.ajax({
                    url: process.env.ROOT_API + '/process-po',
                    type: "POST",
                    data:{
                        po_id:selectedRows,
                        flag:flag,
                        type:'multiple'
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        if (data.content == "part-error") {
                            self.$swal('',data.message,'info');
                        }
                        self.loadList();

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        self.generateStatusCodeMessage(jqXHR,true,'process-vendor-po')
                    }
                });
            },
            recordReceipt: function(){
                var self = this;
                var selectedRows = [];
                var data = this.$refs['listPurchaseOrder'].selectedRows;

                for (var i = 0; i < data.length; i++) {
                    if (self.$refs['listPurchaseOrder'].selectedRows[i].status == 'Closed'){
                        self.$swal('','Purchase order already closed','info');
                        return;
                    }
                    if (self.$refs['listPurchaseOrder'].selectedRows[i].type == 'sublet_po'){
                        self.$swal('','Record Receipt cannot be created from sublet PO','info');
                        return;
                    }
                    if (self.$refs['listPurchaseOrder'].selectedRows[i].type == 'equipment-osr'){
                        self.$swal('','Record Receipt cannot be created from Equipment OSR PO','info');
                        return;
                    }
                    if (self.$refs['listPurchaseOrder'].selectedRows[i].type == 'equipment'){
                        self.$swal('','Record Receipt cannot be created from Equipment PO','info');
                        return;
                    }
                    if (self.$refs['listPurchaseOrder'].selectedRows[i].is_processed == 'NO'){
                        self.$swal('','Please process purchase order first','info');
                        return;
                    }
                    selectedRows.push(self.$refs['listPurchaseOrder'].selectedRows[i].id)
                }

                if (selectedRows.length > 1){
                    self.$swal('','You can record receipt for one purchase order at a time','info');
                    return;
                }

                self.$router.push('/record-receipt?po='+selectedRows[0]);
            },
            selectionChanged:function(param){
                var self = this;
                self.processBtn = false;
                self.unProcessBtn = false;
                self.recordReceiptBtn = false;
                var processedArr = [];
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                var poTypeArr = [];
                var data = this.$refs['listPurchaseOrder'].selectedRows;
                for (var i = 0;i < data.length;i++) {
                    if (data[i] != undefined) {
                        if (data[i] != null) {
                            if (data[i].is_processed != undefined && data[i].is_processed != null) {
                                processedArr.push(data[i].is_processed.toLowerCase());
                            }
                            if (data[i].typeName != undefined && data[i].typeName != null) {
                                poTypeArr.push(data[i].typeName.toLowerCase());
                            }
                        }
                    }
                }
                //hide record receipt button in case if selected po contains type with equipment and equipment osr
                if (!poTypeArr.includes("equipment") && !poTypeArr.includes("equipment-osr")) {
                    self.recordReceiptBtn = true;
                }
                //check all values in array are equal or not
                const allEqual = arr => arr.every( v => v === arr[0] );
                var found = allEqual(processedArr);
                if ( found ) {
                    if (processedArr[0] == "no") {
                        self.processBtn = true;
                    }else{
                        self.unProcessBtn = true;
                    }
                }
            },
            purchaseOrderCopy() {
                var self = this;
                if ( this.$refs['listPurchaseOrder'].selectedRows.length != 1 ) {
                    self.$swal('',"Kindly choose only one purchase order.",'info');
                    return;
                }
                var poDataArr = this.$refs['listPurchaseOrder'].selectedRows;
                var poTypeVal = poDataArr[0].type;
                if (poTypeVal != undefined && poTypeVal != null && poTypeVal != "") {
                    if (poTypeVal == "item" || poTypeVal == "misc") {
                        if (poDataArr[0].id != undefined && poDataArr[0].id != null && poDataArr[0].id != "") {
                            self.copyPOId = poDataArr[0].id;
                            if (self.copyPOId != "") {
                                if (poDataArr[0].po_no != undefined && poDataArr[0].po_no != null && poDataArr[0].po_no != "") {
                                    self.copyPONo = poDataArr[0].po_no;
                                    $("#copy-purchaseorder-modal").modal("show");
                                }
                            }
                        }
                    }else{
                        self.$swal('',"Kindly choose Purchase Order with type Item or Misc.",'info');
                        return;
                    }
                }
            },
            createCopyPO() {
                var self = this;
                // var fields = $("#poCopyForm").serializeArray();
                // fields.push({
                //     name: "from",
                //     value: "copy"
                // });
                // fields.push({
                //     name: "id",
                //     value: ""
                // });
                // fields.push({
                //     name: "po_id",
                //     value: self.copyPOId
                // });
                // self.loadingModal = true;
                // $.ajax({
                //     url: process.env.ROOT_API + "/purchaseorder/copy",
                //     type: "POST",
                //     data: fields,
                //     headers: {
                //         "Accept": "application/json",
                //         "Authorization": "Bearer " + localStorage.getItem("tkn"),
                //         "Access-Control-Allow-Headers": "Origin, Content-Type, Authorization,X-Requested-With",
                //         "Cache-Control": "no-cache"
                //     },
                //     dataType: "json",
                //     success: function (data) {
                //         self.loadingModal = false;
                //         if (data.status == "success") {
                //             if (data.content.id != undefined && data.content.id != null) {
                                $("#copy-purchaseorder-modal").modal("hide");
                                self.$router.push({name: 'VendorPurchaseOrderCreate',params:{copy_id:self.copyPOId,reverse_po:self.reverse_po}});
                            // }else{
                            //     self.$swal('',data.message,'info');
                            // }
                        // }else{
                        //     self.$swal('',data.message,'info');
                        // }
                    // },
                //     error: function (jqXHR, exception) {
                //         self.loadingModal = false;
                //         self.generateStatusCodeMessage(jqXHR, true, 'copy-purchase-order');
                //     },
                // });
            },
            hideCopyPOModal() {
                var self = this;
                $("#copy-purchaseorder-modal").modal("hide");
                self.copyPOId = "";
                self.copyPONo = "";
                self.reverse_po = 0;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/VendorPurchaseOrderList.vue